import { render, staticRenderFns } from "./QBook.vue?vue&type=template&id=1f4da35c&scoped=true&"
import script from "./QBook.vue?vue&type=script&lang=js&"
export * from "./QBook.vue?vue&type=script&lang=js&"
import style0 from "./QBook.vue?vue&type=style&index=0&id=1f4da35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4da35c",
  null
  
)

export default component.exports